export enum UserRoleEnum {
  Admin = 'admin',
  Agency = 'agency',
  Private = 'private',
  User = 'user',
  Host = 'host',
}
